import './styles/spinbox.scss';
import './spinbox.js';
import './controllers/spinboxController.js';
import './directives/spinboxDirectives.js';